
import { ReportMetadata } from './types';

export const REPORT_METADATA_PREFIX = 'report-';

class ReportsMetadataLocalStore {
  addReportMetadata(reportGuid: string, reportMetadata: ReportMetadata) {
    window.localStorage.setItem(`${REPORT_METADATA_PREFIX}${reportGuid}`, JSON.stringify(reportMetadata));
  }

  deleteReportMetadata(reportGuid: string, withPrefix: boolean = true) {
    const prefix = withPrefix ? `${REPORT_METADATA_PREFIX}` : '';
    window.localStorage.removeItem(`${prefix}${reportGuid}`);
  }

  getReportMetadata(reportGuid: string): ReportMetadata | null {
    const reportMetadataJSON = window.localStorage.getItem(`${REPORT_METADATA_PREFIX}${reportGuid}`);
    return reportMetadataJSON ? JSON.parse(reportMetadataJSON) : null;
  };

  getReportKeys() {
    return Object.keys(window.localStorage).filter(key => key.toString().startsWith(REPORT_METADATA_PREFIX))
  } 
}

export const reportsMetadataLocalStore = new ReportsMetadataLocalStore();
